import { render, staticRenderFns } from "./ContentCreateForm.vue?vue&type=template&id=1f0317ee&"
import script from "./ContentCreateForm.vue?vue&type=script&lang=ts&"
export * from "./ContentCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports